import { render, staticRenderFns } from "./duplicate.vue?vue&type=template&id=2aaaa1dc"
import script from "./duplicate.vue?vue&type=script&lang=js"
export * from "./duplicate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports